module.exports = __webpack_public_path__ + "img/cv.d03136f6.svg";